import { render, staticRenderFns } from "./UserWalletTransactionAdd.vue?vue&type=template&id=675adb5f&"
import script from "./UserWalletTransactionAdd.vue?vue&type=script&lang=js&"
export * from "./UserWalletTransactionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports